import http from '../http';
import type { IPage } from '@/types/common';

interface IPageOrderList extends IPage {
  tab: String;
}

interface IWithdrawOrderData {
  orderNo: string;
  // 其他可能存在的属性
  [key: string]: any; // 如果有不确定的其他属性
}


export default {
  // 获取用户设置的提现支付列表
  getWithdrawMethodList(data: object) {
    return http.get('/withdrawal/method', data)
  },
  // 获取渠道列表
  getWithdrawChannelList(data: object) {
    return http.get('/withdrawal/channel', data)
  },
  // 创建新的支付方式
  createWithdrawMethod(data: object) {
    return http.post('/withdrawal/method', data)
  },
  // 更新支付方式
  updateWithdrawMethod(data: object) {
    return http.put('/withdrawal/method/' + (data as any).methodId, data)
  },
  // 删除支付方式
  deleteWithdrawMethod(method_id: number) {
    return http.delete('/withdrawal/method/' + method_id)
  },
  // 创建提现订单
  createWithdrawOrder(data: object) {
    return http.post('/withdrawal/order', data)
  },
  // 获取提现配置
  getWithdrawConfig(data: object) {
    return http.post('/withdrawal/config', data)
  },
  // 主播获取订单列表
  getAnchorWithdrawOrderList(data: IPageOrderList) {
    return http.get('/withdrawal/order/user', data)
  },
  // 代理获取订单列表
  getAgentWithdrawOrderList(data: IPageOrderList) {
    return http.get('/withdrawal/order/agent', data)
  },
  // 拒绝订单
  refuseWithdrawOrder(orderNo: String) {
    return http.put('/withdrawal/order/agent/refuse/' + orderNo)
  },
  // 代理确认订单
  confirmWithdrawOrder(data: IWithdrawOrderData) {
    return http.put('/withdrawal/order/agent/confirm/' + data.orderNo, data  )
  },
  // 用户确认订单
  confirmUserWithdrawOrder(orderNo: String) {
    return http.put('/withdrawal/order/confirm/' + orderNo)
  },
  // 订单转售后
  transferAfterSale(orderNo: String) {
    return http.put('/withdrawal/order/dispute/' + orderNo) 
  },
  // 获取提现用户身份
  getWithdrawUserIdentity(data: object) {
    return http.get('/withdrawal/identity', data)
  },
}
